import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import SectionItem from "../../../../components/section/section-item/SectionItem";
import SectionItemSubtitle from "../../../../components/section/section-item/SectionItemSubtitle";
import MultiToggleOptions from "../../../../components/toggles/MultiToggleOptions";
import { updateContactsMode } from "../../../../redux/actions/CompanyDirectoryActions";
import ContactsAccordion from "../contacts-accordion/ContactsAccordion";
import NetsapiensAutoSyncSection from "../netsapiens-auto-sync-section/NetsapiensAutoSyncSection";

const ContactsWrapper = () => {
  const dispatch = useDispatch();
  const { supportedContactsInputMethods, updatedContactsMode } = useSelector((state) => state.companyDirectory);

  const handleModeChange = (option) => {
    const mode = supportedContactsInputMethods.find((method) => method.label === option);
    dispatch(updateContactsMode(mode.id));
  };

  const selectedOption = useMemo(() => {
    return supportedContactsInputMethods.find((method) => method.id === updatedContactsMode)?.label || null;
  }, [supportedContactsInputMethods, updatedContactsMode]);

  useEffect(() => {
    if (supportedContactsInputMethods.length === 1) {
      dispatch(updateContactsMode(supportedContactsInputMethods[0].id));
    }
  }, [supportedContactsInputMethods, dispatch]);

  if (supportedContactsInputMethods.length === 0) {
    return (
      <SectionItem
        title="Contacts"
        subtitle="Your account does not support contacts. Please contact support for more information."
      />
    );
  }

  const contactsWrapperContent = (
    <div className="flex flex-col w-full gap-4">
      {supportedContactsInputMethods.length > 1 && (
        <MultiToggleOptions
          options={supportedContactsInputMethods.map((inputMethod) => inputMethod.label)}
          selectedOption={selectedOption}
          setSelectedOption={handleModeChange}
        />
      )}
      {updatedContactsMode === "netsapiens" && (
        <>
          <SectionItemSubtitle subtitle="Sync your company directory with your domain directory to automatically keep employee data up to date." />
          <NetsapiensAutoSyncSection />
        </>
      )}
      {updatedContactsMode === "manual-input" && (
        <>
          <SectionItemSubtitle subtitle="Set your company directory manually for curated and precise data control." />
          <ContactsAccordion />
        </>
      )}
    </div>
  );

  return (
    <SectionItem
      title="Contacts"
      subtitle="Contacts' are the individuals, teams, or departments to whom you'd like to route your calls. Each contact needs to have a direct phone number."
      content={contactsWrapperContent}
    />
  );
};

export default ContactsWrapper;
